module.exports = __webpack_public_path__ + "img/clinique_ovo.ddef1aa2.png";